
/**
 * Debug Utilities
 * Centralized debugging functions that respect environment configuration
 */

import { config } from '@/config/environment';

// Debug function that respects environment configuration
export const debugLog = (message: string, ...args: any[]) => {
  if (config.debug) {
    console.log(`[DEBUG] ${message}`, ...args);
  }
};

// Specific debug function for vote flow
export const debugVoteFlow = (message: string, ...args: any[]) => {
  if (config.debug) {
    console.log(`[VOTE_DEBUG] ${message}`, ...args);
  }
};

// Performance debugging
export const debugPerformance = (message: string, ...args: any[]) => {
  if (config.debug && config.features.performanceMonitoring) {
    console.log(`[PERF_DEBUG] ${message}`, ...args);
  }
};

// Error debugging
export const debugError = (message: string, error: Error, ...args: any[]) => {
  if (config.debug) {
    console.error(`[ERROR_DEBUG] ${message}`, error, ...args);
  }
};
